import { useParams } from "react-router-dom";
import FinanceSite from "../../../components/Dashboards/Finance/site";
function FinanceSitePage() {
  const { id } = useParams();
  return <FinanceSite site_id={id as string} />;
}

export default FinanceSitePage;
